import { render, staticRenderFns } from "./wikiNodeCreate.vue?vue&type=template&id=9de7ad08&"
import script from "./wikiNodeCreate.vue?vue&type=script&lang=ts&"
export * from "./wikiNodeCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports